import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './ProductZipCodeContainer-hashed.scss';
import templateStr from 'text!./ProductZipCodeContainer.html';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            postalCode: '=',
            startNewQuote: '&',
            retrieveQuote: '&',
            quoteId: '=',
            isRetrieveStateActive: '=',
            activateItemRetrieval: '&',
            deActivateRetrieveState: '&'
        },
        template: cssUtil.hashTemplate(templateStr, styles),
        controller: ['$scope', '$filter', function ($scope, $filter) {
            $scope.startQuote = function (zipCodeForm) {
                zipCodeForm.submitted = true;
                if (!new RegExp('[tT][0-9][a-zA-Z][ ]?[0-9][a-zA-Z][0-9]$').test($scope.postalCode.value)) {
                    $scope.postalCodeErrorMessage = $filter('translate')('quoteandbind.pa.directives.templates.pa-quick-address-info.Invalid postal code');
                    $scope.validity = false;
                    return;
                }
                $scope.startNewQuote();
            };
            $scope.$watch('postalCode.value', function (newValue, oldValue) {
                if (newValue && newValue.replace(' ', '').length == 6) {
                    if (!new RegExp('[tT][0-9][a-zA-Z][ ]?[0-9][a-zA-Z][0-9]$').test(newValue)) {
                        $scope.postalCodeErrorMessage = $filter('translate')('quoteandbind.pa.directives.templates.pa-quick-address-info.Invalid postal code');
                        $scope.validity = false;
                    } else {
                        $scope.postalCodeErrorMessage = undefined;
                        $scope.validity = undefined;
                    }
                } else if (newValue && newValue.replace(' ', '').length != 6) {
                    $scope.postalCodeErrorMessage = $filter('translate')('quoteandbind.pa.directives.templates.pa-quick-address-info.Invalid postal code');
                    $scope.validity = false;
                }
            });

            $scope.startRetrieveQuote = function (quoteIdForm, zipCodeForm) {
                quoteIdForm.submitted = true;
                zipCodeForm.submitted = true;

                if (!$scope.quoteId.aspects.valid || !$scope.postalCode.aspects.valid) {
                    return;
                }
                $scope.retrieveQuote();
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/directives/ProductZipCodeContainer/ProductZipCodeContainer.js
// module id = 852
// module chunks = 0